<input *ngIf="question && question.behaviourSeenInput" type="hidden" [name]="question.behaviourSeenInput.name"
    [value]="question.behaviourSeenInput.value" >
